import { render } from "./StacksPage.vue?vue&type=template&id=1dee7609&ts=true"
import script from "./StacksPage.vue?vue&type=script&lang=ts"
export * from "./StacksPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__